<template>
  <div class="buy-page">
    <header class="simple-head"><button @click="$router.back()">‹</button><h1>{{ productTitle }}</h1><i></i></header>
    <main class="buy-main">
      <section class="detail-card">
        <div class="product-art"><img src="@/assets/img/doge-slices/icon-doge.png" alt="DOGE"></div>
        <h2>{{ productTitle }}</h2>
        <div v-if="!isJarTwo" class="row"><span>{{ $t('buyPage.dailyOutput') }}</span><b>{{ percent(product.daily_rate) }}</b></div>
        <div v-if="Number(product.product_type) === 2" class="row"><span>{{ isZh ? '余额放大倍数' : 'Balance Multiplier' }}</span><b>{{ Number(product.balance_multiplier || 0) }}x</b></div>
        <div v-if="Number(product.product_type) === 2" class="row"><span>{{ isZh ? '每日递减释放' : 'Daily Declining Release' }}</span><b>{{ percent(product.release_rate) }}</b></div>
        <div v-if="!isJarTwo" class="row"><span>{{ isFlexibleProduct ? (isZh ? '随进随出期' : 'Flexible Exit Period') : (isZh ? '固定周期' : 'Fixed Term') }}</span><b>{{ periodText }}</b></div>
        <div v-if="!isJarTwo" class="row"><span>{{ $t('buyPage.investmentType') }}</span><b>{{ modeText }}</b></div>
        <div v-if="!isJarTwo" class="row"><span>{{ isZh ? '到期规则' : 'Maturity Rule' }}</span><b>{{ fixedRuleText }}</b></div>
        <div class="row"><span>{{ $t('buyPage.purchaseAmount') }}</span><b>{{ amountRangeText }}</b></div>
        <div v-if="isJarTwo" class="row"><span>{{ isZh ? '规则' : 'Rule' }}</span><b>{{ isZh ? '每日递减释放，不可转出' : 'Daily release; no withdrawal' }}</b></div>
        <div v-if="isTopUp" class="row"><span>{{ isZh ? '当前余额' : 'Current balance' }}</span><b>{{ Number(position.compound_balance || 0).toFixed(2) }} USDT</b></div>
        <div class="amount-box">
          <label>{{ isTopUp ? (isZh ? '输入转入金额' : 'Top-up amount') : (isZh ? '输入购买金额' : 'Purchase Amount') }}</label>
          <div><input v-model="amount" type="number" inputmode="decimal" :placeholder="amountPlaceholder"><span>USDT</span></div>
          <p>{{ amountHintText }}</p><p v-if="isJarTwo">{{ isZh ? "放大后增加余额：" : "Balance increase: " }}{{ (Number(amount || 0) * Number(product.balance_multiplier || 0)).toFixed(2) }} USDT</p>
        </div>
      </section>
      <button class="buy-btn" :disabled="buying || !product.id || (isTopUp && !position.id)" @click="buy">{{ buying ? $t('buyPage.buying') : isTopUp ? (isZh ? '确认转入' : 'Confirm top-up') : $t('buyPage.buyNow') }}</button>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'buyPage',
  props: { packageId: { type: [String, Number], required: false } },
  data() { return { product: {}, position: {}, amount: '', buying: false }; },
  computed: {
    ...mapGetters(['getWalletAddress']),
    isZh() { return !this.$i18n || this.$i18n.locale !== 'en'; },
    isJarTwo() { return Number(this.product.product_type) === 2; },
    isTopUp() { return Boolean(this.$route.query.position_id); },
    minAmount() { return Number(this.product && this.product.min_amount) || 0; },
    maxAmount() { return Number(this.product && this.product.max_amount) || 0; },
    graceDays() { return Number(this.product && this.product.grace_days) || 0; },
    waitDays() { return Number(this.product && this.product.redeem_wait_days) || 0; },
    isFlexibleProduct() { return this.graceDays > 0; },
    periodText() {
      if (this.isFlexibleProduct) return this.graceDays + (this.isZh ? '天' : ' days');
      return this.waitDays > 0 ? this.waitDays + (this.isZh ? '天' : ' days') : (this.isZh ? '固定收益' : 'Fixed-term');
    },
    modeText() {
      if (this.isZh) return this.isFlexibleProduct ? `前${this.graceDays}天随进随出` : `${this.waitDays || 30}天固定收益`;
      return this.isFlexibleProduct ? `Flexible exit for first ${this.graceDays} days` : `${this.waitDays || 30}-day fixed-term`;
    },
    fixedRuleText() {
      const windowHours = Number(this.product && this.product.redeem_window_hours) || 0;
      if (this.isFlexibleProduct) {
        if (this.isZh) return this.waitDays > 0 ? `犹豫期后申请，${this.waitDays}天后可转出${windowHours ? `（${windowHours}小时窗口）` : ''}` : '犹豫期内可转出';
        return this.waitDays > 0 ? `After flexible period, withdraw ${this.waitDays} days after request${windowHours ? ` (${windowHours}h window)` : ''}` : 'Transfer out during flexible period';
      }
      if (this.isZh) return `${this.waitDays || 30}天到期退本退息`;
      return `Principal and profit returned after ${this.waitDays || 30} days`;
    },
    amountRangeText() {
      if (this.minAmount > 0 && this.maxAmount > 0) return `${this.money(this.minAmount)} - ${this.money(this.maxAmount)} USDT`;
      if (this.minAmount > 0) return `≥ ${this.money(this.minAmount)} USDT`;
      if (this.maxAmount > 0) return `≤ ${this.money(this.maxAmount)} USDT`;
      return this.isZh ? '不限金额' : 'No limit';
    },
    amountPlaceholder() {
      return this.minAmount > 0 ? this.money(this.minAmount) : (this.isZh ? '请输入购买金额' : 'Enter amount');
    },
    amountHintText() {
      return this.isZh ? `可购买金额：${this.amountRangeText}` : `Allowed amount: ${this.amountRangeText}`;
    },
    productTitle() {
      const name = this.product.name || '';
      if (this.$i18n && this.$i18n.locale === 'en' && /[\u4e00-\u9fff]/.test(name)) {
        const m = name.match(/套餐\s*(\d+)/);
        return m ? `Package ${m[1]}` : this.$t('buyPage.assetPackage');
      }
      return name || this.$t('buyPage.assetPackage');
    }
  },
  mounted() { this.load(); },
  methods: {
    async load() {
      try {
        const r = await this.$axios.get('/api/doge/products');
        const list = r.data.data || [];
        this.product = list.find(x => String(x.id) === String(this.packageId || this.$route.params.packageId)) || {};
        if (this.isTopUp) {
          await this.$store.dispatch('ensureDogeAuth');
          const positions = await this.$axios.get('/api/doge/positions', { params: { position_id: this.$route.query.position_id } });
          const rows = (positions.data.data && positions.data.data.data) || positions.data.data || [];
          this.position = rows.find(x => String(x.id) === String(this.$route.query.position_id) && Number(x.product_type) === 2 && Number(x.status) === 1) || {};
        }
        this.amount = this.minAmount > 0 ? String(this.minAmount) : '';
      } catch (e) {
        this.product = {};
      }
    },
    async buy() {
      let walletAddress = this.getWalletAddress;
      if (!walletAddress && window.ethereum) {
        try {
          const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
          if (accounts && accounts[0]) {
            walletAddress = accounts[0];
            this.$store.dispatch('updateWalletAddress', walletAddress);
          }
        } catch (e) {}
      }
      if (!walletAddress) return this.msg(this.$t('buyPage.alerts.connectWalletFirst'));
      if (this.isTopUp && !this.position.id) return this.msg(this.isZh ? '订单不可转入' : 'Order unavailable for top-up');
      if (!this.product.id) return this.msg(this.$t('buyPage.alerts.productUnavailable'));
      const buyAmount = Number(this.amount);
      if (!buyAmount || buyAmount <= 0) return this.msg(this.$t('buyPage.alerts.invalidAmount'));
      if (this.minAmount > 0 && buyAmount < this.minAmount) return this.msg(this.$t('buyPage.alerts.amountTooLow').replace('{min}', this.money(this.minAmount)));
      if (this.maxAmount > 0 && buyAmount > this.maxAmount) return this.msg(this.$t('buyPage.alerts.amountTooHigh').replace('{max}', this.money(this.maxAmount)));
      this.buying = true;
      try {
        await this.$store.dispatch('ensureDogeAuth');
        const r = await this.$axios.post(this.isTopUp ? '/api/doge/top_up' : '/api/doge/buy', { product_id: this.product.id, position_id: this.isTopUp ? this.position.id : undefined, amount: buyAmount, wallet_address: walletAddress });
        if (![1, 200].includes(Number(r.data.code))) throw new Error(r.data.message || r.data.msg);
        this.msg(this.$t('buyPage.alerts.purchaseSuccessSimple'), 'success');
        this.$router.push({ name: 'recordList' });
      } catch (e) {
        this.msg(this.localizeBuyError((e.response && e.response.data && (e.response.data.message || e.response.data.msg)) || e.message || this.$t('buyPage.alerts.purchaseFailed')));
      } finally { this.buying = false; }
    },
    localizeBuyError(message) {
      if (!message || !this.$i18n || this.$i18n.locale !== 'en') return message;
      const text = String(message);
      const rules = [
        [/请先连接钱包|钱包未连接/i, 'Please connect your wallet first.'],
        [/钱包地址不正确|地址不正确/i, 'Wallet address is invalid. Please reconnect your wallet.'],
        [/获取签名信息失败|签名信息/i, 'Failed to get signature information.'],
        [/钱包签名验证失败|签名验证失败/i, 'Wallet signature verification failed.'],
        [/钱包签名登录失败|签名登录失败/i, 'Wallet signature login failed.'],
        [/资产包不存在|已下架|套餐不存在/i, 'Asset package does not exist or has been removed.'],
        [/余额不足|账户余额不足/i, 'Insufficient balance.'],
        [/请先设置交易密码|支付密码|交易密码/i, 'Please set or enter your transaction password.'],
        [/买入失败|购买失败/i, 'Purchase failed. Please try again.'],
        [/买入成功|购买成功/i, 'Purchase successful!'],
        [/用户不存在|账户不存在/i, 'Account does not exist. Please reconnect your wallet.'],
        [/网络|服务器/i, 'Network or server error. Please try again.']
      ];
      const found = rules.find(([pattern]) => pattern.test(text));
      return found ? found[1] : text;
    },
    money(v) { return Number(v || 0).toFixed(0); },
    percent(v) { return (Number(v || 0) * 100).toFixed(1) + '%'; },
    msg(t, type = 'info') { this.$messageDialog ? this.$messageDialog.alert(t, this.$t('common.info'), type) : alert(t); }
  }
};
</script>

<style scoped>
.buy-page{min-height:100vh;background:#f6f0dc;color:#211507;font-family:Arial,"PingFang SC","Microsoft YaHei",sans-serif}.simple-head{height:60px;background:#fff;display:flex;align-items:center;justify-content:space-between;padding:0 14px;box-shadow:0 4px 18px rgba(75,52,0,.05)}.simple-head button{width:36px;height:36px;border:0;background:transparent;font-size:34px;color:#d39b2c;line-height:30px}.simple-head h1{margin:0;font-size:20px;color:#d39b2c}.simple-head i{width:36px}.buy-main{padding:18px 18px 116px}.detail-card{background:#fff;border-radius:28px;padding:20px 20px 18px;box-shadow:0 9px 24px rgba(76,50,0,.065)}.product-art{width:118px;height:118px;border-radius:34px;margin:0 auto 18px;background:#f5ecd6;display:flex;align-items:center;justify-content:center}.product-art img{width:66px;height:80px;object-fit:contain;filter:drop-shadow(0 8px 14px rgba(102,62,0,.18))}.detail-card h2{text-align:center;margin:0 0 20px;font-size:24px}.row{min-height:52px;border-bottom:1px solid #eee4ce;display:flex;align-items:center;justify-content:space-between;color:#7b7162;gap:12px}.row b{color:#d39b2c;text-align:right}.amount-box{margin-top:18px;background:#fff8e8;border:1px solid #f0dfb6;border-radius:18px;padding:14px}.amount-box label{display:block;font-size:13px;color:#7b7162;font-weight:800;margin-bottom:8px}.amount-box div{height:44px;background:#fff;border-radius:12px;border:1px solid #ead7a8;display:flex;align-items:center;padding:0 12px}.amount-box input{min-width:0;flex:1;border:0;outline:0;font-size:18px;font-weight:800;color:#211507;background:transparent}.amount-box span{color:#d39b2c;font-weight:900}.amount-box p{margin:8px 0 0;color:#a1844a;font-size:12px}.buy-btn{position:fixed;left:24px;right:24px;bottom:22px;height:52px;border:0;border-radius:999px;background:linear-gradient(90deg,#d89a2e,#eccb74);color:#fff;font-size:17px;font-weight:900;box-shadow:0 10px 24px rgba(194,132,24,.28)}
</style>
